import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radioButton", "showable"]

  connect() {
    const selected = this.radioButtonTargets.find(btn => btn.checked)
    if (selected) this.toggle(selected)
  }

  change(event) {
    this.toggle(event.target)
  }

  toggle(btn) {
    const container = btn.parentElement.parentElement

    this.showableTargets.forEach(el => {
      if (el.dataset.buttonValue === btn.value) {
        // move it immediately after the radio's parent
        container.insertAdjacentElement("afterend", el)
        el.style.display = ""
        el.style.visibility = ""
      } else {
        el.style.display = "none"
        el.style.visibility = "hidden"
      }
    })
  }
}
